<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <!-- <el-button class="title_btn" type="primary" size="" @click="addBtn()">등록</el-button> -->
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <div class="table_search">
              <el-row>
                <el-col :span="12">
                  <span class="t_s_title">정품등록</span>
                  <span class="el-checkbox-group">
                    <el-radio-group v-model="filterSet">
                      <el-radio :label="''">전체</el-radio>
                      <el-radio :label="1">미등록</el-radio>
                      <el-radio :label="2">등록</el-radio>
                    </el-radio-group>
                  </span>
                </el-col>
                <el-col :span="12">
                  <span class="t_s_title">제품타입</span>
                  <span class="el-checkbox-group">
                    <el-radio-group v-model="s_type">
                      <el-radio :label="''">전체</el-radio>
                      <el-radio :label="1">세이프티씰</el-radio>
                      <el-radio :label="2">세이프티드라이브</el-radio>
                      <el-radio :label="3">세이프티플렉스</el-radio>
                    </el-radio-group>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="search_btn_wrap text_center">
              <el-button type="primary" @click="[getList(), page=1]">검색</el-button>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%"
              empty-text="데이터가 없습니다."
              v-loading="tableLoading"
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width

                               :class-name = header.class
              ></el-table-column>
              <el-table-column v-if="tableoption"
                               align="center"
                               width="100"
                               label="옵션"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size="10"
              :pager-count="filterPagnation.pagerCount"
              layout="prev, pager, next"
              :current-page.sync="page"
              :total="listTotal"
              @current-change="getList"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import sessionStorage from '@/mixins/sessionStorage';
  import localStorage from '@/mixins/localStorage'
  import util from '@/mixins/util'
  import {countryList} from "@/service/countryService";

  let params = {};
  export default {
    name: "Product",
    components: {},
    mixins: [ VuxAlert, sessionStorage ,localStorage ],
    data(){
      return{
        userInfo : this.getUserInfo(),
        tableLoading: true,
        data : {},
        title: this.$route.meta.title,
        tableData: [],
		  tableSearch: '',
		c_idx: '',
		s_type: '',
        tableHeader: [
          {
            label : 'code',
            prop : 'SafetyBell[0].s_code',
            class: 'text_center'
          },{
            label : 'shot code',
            prop : 'SafetyBell[0].s_code_short',
            class: 'text_center'
          },{
            label: '라이센스',
            prop: 'pl_title',
            class: 'text_center'
          },{
			  label: '제품분류',
			  prop: 's_type_name',
			  class: 'text_center'
		  },{
            label: '타이틀',
            prop: 'SafetyBell[0].s_title',
            class: 'text_center'
          },{
            label: '링크',
            prop: 'SafetyBell[0].s_shortLink',
            class: 'text_center'
          },{
            label: '유효기간',
            prop: 's_is_guarantee_day_reform',
            class: 'text_center'
          },{
            label: '정품등록유무',
            prop: 'has_member',
            class: 'text_center'
          },{
            label: '등록회원',
            prop: 'mb_id',
            class: 'text_center'
          },{
            label: '생성일',
            prop: 'SafetyBell[0].created_at',
            class: 'text_center'
          }
        ],
        tableoption: false,
        pagnation: {
          size: 10,
          pagerCount: 11,
          page: 1,
        },
        page : 1,
        lastPage: 0,
        listTotal: 0,
        tableSelected: '',
        tableSelectOption: [
          {
            label: '제목',
            value: 'v_title'
          }
        ],
        filterType: '',
        filterTypeList: [],
        filterSet : '',
      }
    },

    created() {
      /*if(this.$sessionStorage.get('first')){
        this.$sessionStorage.set('first' , false);
        location.reload();
	  }*/
	  if(this.$route.params.pl_idx) {
		  this.filterType = this.$route.params.pl_idx
	  }
    },
    computed: {
      tableFilter() {
        return this.tableData
      },
      filterPagnation() {
        // this.resetPage()
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getCountryList();
      this.getList();
    },

    beforeRouteLeave(to, from, next){
      if(to.path === "/auth" && this.$route.query.first){
        next(false);
      }else{
        return next();
      }
    },

    methods: {
      getCountryList(){
        this.$api.$user.getCountry()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : '대한민국'},{c_idx : 2 , CO_NAME_KOR : '일본'}];
            this.category = countryList;
          });
      },
      addBtn(){
        this.$router.push('/method/detail');
      },

      resetPage() {
        this.page = 1
      },
      getList() {
        this.tableLoading = true;
        let params = {
          page: this.page,
          ip : 1,
          type : 'basic'
        }
        if(this.filterType != '') {
          params.pl_idx = this.filterType;
        }
        if(this.filterSet != '') {
          params.s_is_auth = this.filterSet -1;
        }
        if(this.userInfo.g_idx === 2){
          params.c_idx = this.userInfo.c_idx;
        }else{
          if(this.c_idx){
            params.c_idx = this.c_idx;
          }
        }
        if(this.s_type != '') {
          params.s_type = this.s_type;
        }
        this.$api.$product.getProductList(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            util.each(this.tableData, (item, index, allItems) => {
              item.pl_title = item.License[0].pl_title;
              item.s_is_guarantee_day_reform = item.SafetyBell[0].LeftGuaranteeDay.hasOwnProperty('days') ?  item.SafetyBell[0].LeftGuaranteeDay.days * -1 + '일' : '-';
              item.has_member = item.MemberInfo.length > 0 ? '등록완료' : '미등록';
              item.mb_id = item.MemberInfo.length > 0 ? item.MemberInfo[0].mb_id : '-';
              item.s_type_name = item.SafetyBell[0].s_type === 1? '세이프티씰' : item.SafetyBell[0].s_type === 2 ? '세이프티드라이브' : item.SafetyBell[0].s_type === 3? '세이프티플렉스' : '';
            });
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }else{
            this.tableData = [];
            this.page = 1;
            this.lastPage = 0;
            this.listTotal = 0;
          }
          this.tableLoading = false;
        })
      },

      handleEdit(index, row) {
        this.$router.push('/member/detail/'+row.mb_no);
      },

      handleDelete(index, row) {
        let alertParams = {'element' : this , 'key' : row.v_idx };
        this.listDeleteAlert(alertParams);

      },

      dataDelete(key){
        let params = {'v_idx' : key}
        this.$api.$method.deleteMethod(params).then( res => res.Data).then(res => {
          if(res.status === true){
            this.page = 1;
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.reason);
          }
        })
      },

      selectChange() {
        //this.tableSearch = "";
      },

      tableIndex(index) {
        return index + this.pagnation.size * (this.page - 1) +1
      },
    }
  }

</script>
